export class PromoSmsModel {
  promoSmsLogId: number;
  promoSmsName: string;
  clientId: number;
  templateId: number;
  customerId: number;
  promoSmsScheduledOn: Date;
  isActive: 'YES' | 'NO' = 'YES';

  constructor(init?: Partial<PromoSmsModel>) {
    Object.assign(this, init);
  }
}